import React from 'react';
import { Grid } from '@mui/material';
import _ from 'lodash';

import { UserPointBreakout } from '../../../types/user/types';
import LeaderboardCategoryPointsItem from './LeaderboardCategoryPointsItem';

type Props = {
  userPoints: UserPointBreakout[] | undefined;
};

const LeaderboardCategoryPoints: React.FC<Props> = ({ userPoints }) => {
  const categories = _.uniq(
    userPoints?.flatMap((up) => up.pointsByCategory.map((pbc) => pbc.category)),
  );
  const categoryPoints: React.ComponentProps<
    typeof LeaderboardCategoryPointsItem
  >['item'][] = categories?.map((category) => ({
    title: category,
    totalPoints:
      userPoints?.reduce(
        (acc, cur) =>
          acc +
          (cur.pointsByCategory.find((pbc) => pbc.category === category)
            ?.points || 0),
        0,
      ) || 0,
    subItems:
      userPoints?.map<
        React.ComponentProps<typeof LeaderboardCategoryPointsItem>['item']
      >((up) => ({
        title: up.month.toString(),
        totalPoints:
          up.pointsByCategory.find((pbc) => pbc.category === category)
            ?.points || 0,
        subItems: up.pointBreakouts
          .filter((pb) => pb.category === category)
          .map((pb) => ({
            title: pb.eventTypeDescription ?? pb.eventType,
            totalPoints: pb.pointTotals,
          })),
      })) ?? [],
  }));

  return (
    <Grid container>
      {categoryPoints.map((cp) => (
        <LeaderboardCategoryPointsItem key={cp.title} item={cp} />
      ))}
    </Grid>
  );
};

export default LeaderboardCategoryPoints;
